// extracted by mini-css-extract-plugin
export var container = "_ij-0";
export var outlet = "_ij-1";
export var outletEnter = "_ij-2";
export var outletEnterActive = "_ij-3";
export var outletExit = "_ij-4";
export var outletExitActive = "_ij-5";